import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useSetLanguage } from '~/pages/layout/hooks/useSetLanguage';
import { useIsSignedIn } from '~/shared/auth/auth-provider.tsx';
import { createRoutes } from '~/routes.ts';

export function AppContent() {
  useSetLanguage();
  const isSignIn = useIsSignedIn();

  if (!isSignIn) {
    return <Navigate to={createRoutes.SignIn} replace />;
  }

  return (
    <Suspense>
      <Outlet />
    </Suspense>
  );
}
